import React, { Fragment, memo, useEffect, useRef, useState, createElement } from "react";
import "./CardPro.scss";

import InvestorCard from "./InvestorCard";
import { KycStatus, LandlordInfo } from "../../models/Devs";
import {
  Box,
  Dialog,
  Grid,
  Modal,
  Snackbar,
  SnackbarCloseReason,
  Tooltip,
} from "@mui/material";
import { getAuthToken, unsetAuth } from "../../../../helpers/authHelper";
import { useDispatch, useSelector } from "react-redux";
import { AppStore } from "../../../../redux/store";
import { changeStatusUnit, sendAssignUnitClient, unassignLandlordToUnit } from "../../services/devsServices";
import { fetchResponseAdapter } from "../../../../adapters/fetchAdapter";
import useCallApiAndLoad from "../../../../hooks/useCallApiAndLoad";

import level1 from "../../../../assets/icons/level-1.png";
import level2 from "../../../../assets/icons/level-2.png";
import level3 from "../../../../assets/icons/level-3.png";
import level4 from "../../../../assets/icons/level-4.png";
import level5 from "../../../../assets/icons/level-5.png";
import { IconBrandWhatsapp, IconLink, IconSquareCheck } from "@tabler/icons-react";
import ColorfulNameComponent from "../ColorfulName/ColorfulName";
import { logoutAction } from "../../../../redux/features/auth";
import { useNavigate } from "react-router-dom";
import templateCard from "./templateCard";
import { UnitType, ViewName } from "./templateCard/types";
import Button from "../../../../components/form/Button";

import { useDetailProjectBookedUsers } from "../../pages/ProjectDetail/hooks/useDetailProjectBookedUsers";

interface ProjectProps {
  unit: UnitType;
  idProject: string;
  unitStatus: string;
  viewName: ViewName;
  getData: ({ load }: { load: boolean }) => void;
}
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: 800,
  bgcolor: "background.paper",
  borderRadius: "20px",
  p: 4,
  "@media(max-width: 768px)": {
    p: 2,
  },
};

const styleOptions = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: 500,
  bgcolor: "background.paper",
  borderRadius: "20px",
  p: 4,
  "@media(max-width: 768px)": {
    p: 2,
  },
};

const generarLinkWhatsApp = (url: string, telefono: string) => {
  const numero = telefono.replace(/[^0-9]/g, "");
  const urlCodificada = encodeURIComponent(url);
  return `https://wa.me/${numero}?text=${urlCodificada}`;
};

const CardPro = memo(
  ({
    unit,
    idProject,
    unitStatus,
    viewName,
    getData
  }: ProjectProps) => {

    const { id, landlordInfo, pre_booking_date, landlord_id } = unit;

    const { country } = useSelector((store: AppStore) => store.country);
    const [userSelected, setUserSelected] = useState("");
    const [landlordInfoSelected, setLandlordInfo] = useState<LandlordInfo>();
    const user = useSelector((store: AppStore) => store.auth);
    const token = getAuthToken(user);
    const [showBidder, setShowBidder] = useState<boolean>(false);
    const [open, setOpen] = useState(false);

    const [openModalOptions, setOpenOptions] = useState(false);

    const { isLoading, callEndpoint } = useCallApiAndLoad();

    const [openDrop, setOpenDrop] = useState(false);
    const dropdownRef = useRef<HTMLDivElement | null>(null);

    const [showShareOption, setShareOption] = useState(false);
    const [selectedOption, setSelectedOption] = useState("");
    const [loadingSend, setLoadingSend] = useState(false);
    const [loadingOptions, setLoadingOptions] = useState(false);
    const [message, setMessage] = useState("");
    const [url, setUrl] = useState<string>("");
    const [isLoadingStatus, setIsLoadingStatus] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();



    // HOMOLOGAR ESTO
    const { bookedUsers, getUsersBooked, bookedUsersLoading } = useDetailProjectBookedUsers();

    // Abrir el modal y primer llamado a informacion de usuarios
    const handleOpen = (idModel: string, idPro: string) => {
      setOpen(true);
      if (idModel && idPro) {
        getUsersBooked(idPro, idModel);
      }
    };

    // cerrar modal
    const handleClose = () => {
      setOpen(false);

      if (url) {
        window.location.reload();
      }
    };

    const handleCloseOptions = () => {
      setOpenOptions(false);
    };

    // obtener primer valor seleccionado

    useEffect(() => {
      if (bookedUsers) {
        const dataBookedUser = (bookedUsers as LandlordInfo[])[0];
        setUserSelected(dataBookedUser?.id);
        setLandlordInfo(dataBookedUser);
      }
    }, [bookedUsers]);

    useEffect(() => {
      if (userSelected) {
        const dataBookedUser = bookedUsers || [];
        const filterSelected = dataBookedUser?.filter(
          (item: any) => item?.id === userSelected
        );
        setLandlordInfo(filterSelected[0]);
      }
    }, [userSelected]);

    const toggleBidder = () => {
      try {
        setShowBidder((old) => !old);
        document.body.style.overflowY = "scroll";
      } catch (error) {
        console.log("something went wrong with bidder info");
      }
    };

    const estado = {
      "available": {
        class: "bg-available_light text-available_dark",
        active: "bg-available_dark text-available_light",
        name: "Disponible",
      },
      "pre_booked": {
        class: "bg-pre_booked_light text-pre_booked_dark",
        active: "bg-pre_booked_dark text-pre_booked_light",
        name: "Pre-reservado"
      },
      "assigned": {
        class: "bg-assigned_light text-assigned_dark",
        active: "bg-assigned_dark text-assigned_light",
        name: "Asignada"
      },
      "created": {
        class: "bg-created_light text-created_dark",
        active: "bg-created_dark text-created_light",
        name: "Creada"
      },
      "disabled": {
        class: "bg-disabled_light text-disabled_dark",
        active: "bg-disabled_dark text-disabled_light",
        name: "Desactivada"
      },
      "taken": {
        class: "bg-taken_light text-taken_dark",
        active: "bg-taken_dark text-taken_light",
        name: "Reservada"
      },
      "signing_promise": {
        class: "bg-signing_promise_light text-signing_promise_dark",
        active: "bg-signing_promise_dark text-signing_promise_light",
        name: "Firma de contrato"
      }
    };

    const assignUnit = async () => {
      const data = {
        unit_id: unit?.id,
        landlord_id: landlordInfoSelected?.id,
      };
      await sendDataAssign(token, data);
    };

    const sendDataAssign = async (
      token: string,
      response: any
    ): Promise<void> => {
      setLoadingSend(true);
      try {
        const { status, data } = await callEndpoint(
          sendAssignUnitClient(idProject, response, token)
        );
        if (status === 401) {
          setLoadingSend(false);
          dispatch(logoutAction({}));
          unsetAuth();
          navigate(`/app/${country}/auth/desarrolladoras/login`);
        }
        if (status === 201) {
          const response = fetchResponseAdapter(data);
          setLoadingSend(false);
          setShareOption(true);

          setUrl(response.data.payment_link);
          getData({ load: false });
          // setDataDetailUnit(response?.data?.items);
        }
      } catch (error) {
        setLoadingSend(false);
        console.log(error);
      }
    };

    const unAssignUnit = async () => {
      const data = {
        unit_id: unit?.id,
        landlord_id: viewName === "Tower" ? landlord_id : landlordInfo?.id,
      };
      await sendDataUnassign(token, data);
    };

    const sendDataUnassign = async (
      token: string,
      response: any
    ): Promise<void> => {
      try {
        const { status, data } = await callEndpoint(
          unassignLandlordToUnit(idProject, response, token)
        );
        if (status === 401) {
          setLoadingOptions(true);
          setMessage("Ha ocurrido un error, intenta más tarde");
          dispatch(logoutAction({}));
          unsetAuth();
          navigate(`/app/${country}/auth/desarrolladoras/login`);
        }
        if (status === 200) {
          const response = fetchResponseAdapter(data);
          setLoadingOptions(true);

          setMessage("La unidad ha sido liberada!");
          handleCloseOptions();
          setTimeout(() => {
            window.location.reload();
          }, 2000);
          getData({ load: false });
          // setDataDetailUnit(response?.data?.items);
        }
      } catch (error) {
        setLoadingOptions(true);
        setMessage("Ha ocurrido un error, intenta más tarde");
        console.log(error);
      }
    };

    const changeStatus = async (status: string) => {
      setIsLoadingStatus(true);
      const data = {
        status: status,
      };
      await sendChangeStatusUnit(token, data);
      setIsLoadingStatus(false);
    };

    const sendChangeStatusUnit = async (
      token: string,
      response: any
    ): Promise<void> => {
      try {
        const { status, data } = await callEndpoint(
          changeStatusUnit(idProject, unit?.id, response, token)
        );
        if (status === 401) {
          setLoadingOptions(true);
          setMessage("Ha ocurrido un error, intenta más tarde");
          dispatch(logoutAction({}));
          unsetAuth();
          navigate(`/app/${country}/auth/desarrolladoras/login`);
        }
        if (status === 200) {
          const response = fetchResponseAdapter(data);
          setLoadingOptions(true);

          setMessage("La unidad ha cambiado su estado!");
          handleCloseOptions();
          // setTimeout(() => {
          //   window.location.reload();
          // }, 2000);
          getData({ load: false });
          // setDataDetailUnit(response?.data?.items);
        }
      } catch (error) {
        setLoadingOptions(true);
        setMessage("Ha ocurrido un error, intenta más tarde");
        console.log(error);
      }
    };

    const handleEnviarWhatsApp = () => {
      const waLink = generarLinkWhatsApp(
        url,
        landlordInfoSelected?.phone as string
      );
      window.open(waLink, "_blank");
    };

    const handleCopiar = () => {
      navigator.clipboard
        .writeText(url)
        .then(() => alert("URL copiada al portapapeles"))
        .catch(() => alert("Error al copiar"));
    };

    useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        if (
          dropdownRef.current &&
          event.target instanceof Node &&
          !dropdownRef.current.contains(event.target)
        ) {
          setOpenDrop(false);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSelect = (value: string) => {
      setSelectedOption(value);
      setOpenOptions(true);
      setOpenDrop(false);
    };

    const handleCloseSnackbar = () => {
      setLoadingOptions(false);
    };

    const viewKyc = () => {
      navigate(`/app/${country}/desarrolladoras/proyectos/${idProject}/${unit?.id}`);
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    };

    const formatKycStatus = (status?: string) => {
      switch (status) {
        case KycStatus.CREATED:
          return "Creado";
        case KycStatus.IN_PROGRESS:
          return "En progreso";
        case KycStatus.IN_REVIEW:
          return "En revisión";
        case KycStatus.NEED_CUSTOMER_REVIEW:
          return "Revisión del cliente";
        case KycStatus.COMPLETED:
          return "Completado";
        case KycStatus.DISABLED:
          return "Deshabilitado";
        case KycStatus.PARTIALLY_COMPLETED:
          return "Parcialmente completado"
        default:
          return "Desconocido";
      }
    };

    return (
      <>
        <Snackbar
          open={loadingOptions}
          onClose={handleCloseSnackbar}
          message={message}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          classes={{ root: "mt-10" }}
          autoHideDuration={2000}
        />

        <Dialog
          open={showBidder}
          onClose={() => toggleBidder()}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <InvestorCard
            onAction={toggleBidder}
            landlordInfo={landlordInfo || null}
            landlordId={landlordInfo?.id || ""}
            pre_booking_date={pre_booking_date}
            idUnit={unit?.id}
          />
        </Dialog>
        {/* <div className="cardPro"> */}
        {createElement(templateCard[viewName],
          {
            unit,
            estado,
            idProject,
            toggleBidder,
            openDrop,
            setOpenDrop,
            dropdownRef,
            handleSelect,
            handleOpen
          }
        )}

        <Modal
          open={openModalOptions}
          onClose={handleCloseOptions}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{
            m: 2,
          }}
        >
          <>
            {selectedOption === "assigned" && (
              <Box sx={styleOptions}>
                <h2 className=" text-xl font-semibold text-[#212121]">
                  Liberad unidad
                </h2>
                <p className="text-sm font-normal text-[#757575]">
                  Al ejecutar esta opción, la unidad quedará disponible
                  nuevamente para reservas, y la prerreserva del inversionista
                  actual será cancelada. ¿Estás seguro?
                </p>
                <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
                  <Button
                    onClick={handleCloseOptions}
                    variant="outlined"
                  >
                    Cancelar
                  </Button>
                  <Button
                    onClick={unAssignUnit}
                    loading={isLoadingStatus}
                  >
                    Liberar
                  </Button>
                </div>
              </Box>
            )}
            {selectedOption === "created" && (
              <Box sx={styleOptions}>
                <h2 className=" text-xl font-semibold text-[#212121]">
                  Habilitar unidad
                </h2>
                <p className="text-sm font-normal text-[#757575]">
                  Al seleccionar esta opción, la unidad será habilitada y
                  volverá a mostrarse en el marketplace de Propi. ¿Estás seguro?
                </p>
                <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
                  <Button
                    onClick={handleCloseOptions}
                    variant="outlined"
                  >
                    Cancelar
                  </Button>
                  <Button
                    onClick={() => changeStatus("available")}
                    loading={isLoadingStatus}
                  >
                    Habilitar
                  </Button>
                </div>
              </Box>
            )}
            {selectedOption === "available" && (
              <Box sx={styleOptions}>
                <h2 className=" text-xl font-semibold text-[#212121]">
                  Deshabilitar unidad
                </h2>
                <p className="text-sm font-normal text-[#757575]">
                  Al seleccionar esta opción, la unidad será deshabilitada y
                  dejará de mostrarse en el marketplace de Propi. ¿Estás seguro?
                </p>
                <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
                  <Button
                    onClick={handleCloseOptions}
                    variant="outlined"
                  >
                    Cancelar
                  </Button>
                  <Button
                    onClick={() => changeStatus("disabled")}
                    loading={isLoadingStatus}
                  >
                    Deshabilitar
                  </Button>
                </div>
              </Box>
            )}
          </>
        </Modal>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <h1 className=" text-xl font-semibold mb-3">
              Pre-reservas activas
            </h1>
            {bookedUsersLoading ? (
              <Box sx={{ p: 4 }}>
                <img
                  src="https://storage.googleapis.com/assets-us-east4-propilatam-dev/website-assets/propi-web/loading_search.gif"
                  alt=""
                  style={{ margin: "auto" }}
                  width={70}
                />
              </Box>
            ) : (
              <Grid sx={{ height: 600 }} container spacing={2}>
                <Grid item xs={12} md={4} sx={{ zIndex: 1 }}>
                  <div className="cardBooked-container">
                    {!bookedUsersLoading && (
                      <>
                        {bookedUsers.map((item: any, index: number) => (
                          <>
                            <div
                              key={index}
                              className={`option-booked ${userSelected === item?.id
                                ? "selected"
                                : "not-selected"
                                }`}
                              onClick={() => setUserSelected(item?.id)}
                            >
                              <h2>{item?.name}</h2>
                              <p className="truncate">{item?.email}</p>
                              <p>{item?.phone}</p>
                            </div>
                          </>
                        ))}
                      </>
                    )}
                  </div>
                </Grid>
                <Grid item xs={12} md={8}>
                  <div className="bg-white rounded-lg h-[435px] lg:h-[600px] overflow-y-auto lg:mx-2">
                    <div className="container_id w-full flex flex-wrap bg-primary px-6 py-4 sticky top-0 z-10 rounded-lg">
                      <div className="w-full lg:w-1/4 flex justify-center items-center">
                        {landlordInfoSelected &&
                          landlordInfoSelected?.avatar ? (
                          <img
                            src={landlordInfoSelected?.avatar}
                            className="object-cover object-center rounded-full w-24 border-4 border-primary mx-auto"
                            alt=""
                          />
                        ) : (
                          <ColorfulNameComponent
                            firstName={
                              landlordInfoSelected?.first_name as string
                            }
                            lastName={landlordInfoSelected?.last_name as string}
                          />
                        )}
                      </div>
                      <div className="w-full lg:w-3/4">
                        <p className=" text-sm text-white text-center lg:text-left mt-2 lg:mt-0">
                          Postulante
                        </p>
                        <h1 className=" text-lg font-semibold text-white mb-2 text-center lg:text-left">
                          {landlordInfoSelected?.first_name}{" "}
                          {landlordInfoSelected?.last_name}
                        </h1>
                        <div className="w-full flex bg-[#2C2E2B] rounded-lg py-2 px-4 items-center">
                          <div className="w-full ">
                            <p className="text-sm text-white font-semibold">
                              Nivel de riesgo
                            </p>
                          </div>
                          <div className="w-full text-white text-right">
                            <>
                              {landlordInfoSelected?.credit_score ? (
                                (() => {
                                  switch (true) {
                                    case landlordInfoSelected?.credit_score <=
                                      100:
                                      return (
                                        <span className="text-sm">
                                          Muy Bajo{" "}
                                          <img
                                            style={{ display: "inherit" }}
                                            src={level1}
                                          />
                                        </span>
                                      );
                                    case landlordInfoSelected?.credit_score <=
                                      300:
                                      return (
                                        <span className="text-sm">
                                          Bajo{" "}
                                          <img
                                            style={{ display: "inherit" }}
                                            src={level2}
                                          />
                                        </span>
                                      );
                                    case landlordInfoSelected?.credit_score <=
                                      600:
                                      return (
                                        <span className="text-sm">
                                          Medio{" "}
                                          <img
                                            style={{ display: "inherit" }}
                                            src={level3}
                                          />
                                        </span>
                                      );
                                    case landlordInfoSelected?.credit_score <=
                                      800:
                                      return (
                                        <span className="text-sm">
                                          Alto{" "}
                                          <img
                                            style={{ display: "inherit" }}
                                            src={level4}
                                          />
                                        </span>
                                      );
                                    case landlordInfoSelected?.credit_score <
                                      1000:
                                      return (
                                        <span className="text-sm">
                                          Excelente{" "}
                                          <img
                                            style={{ display: "inherit" }}
                                            src={level5}
                                          />
                                        </span>
                                      );
                                    default:
                                      return (
                                        <span className="text-sm">
                                          No disponible{" "}
                                        </span>
                                      );
                                  }
                                })()
                              ) : (
                                <span>No disponible.</span>
                              )}
                            </>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="p-4 pt-2 w-full h-86 scrollbar relative">
                      {landlordInfoSelected?.source === "landlord" &&
                        unitStatus === "pre_booked" &&
                        showShareOption !== true &&
                        (landlordInfoSelected?.can_assign_unit === true ? (
                          <div className="w-full mb-2">
                            <div className="w-full flex justify-center items-center gap-2">
                              <button
                                type="button"
                                onClick={assignUnit}
                                className=" px-6 py-1.5 bg-primary rounded-lg text-sm font-medium flex text-white justify-center items-center gap-1"
                              >
                                <IconLink /> Asignar unidad a cliente
                              </button>
                              {loadingSend && (
                                <Box>
                                  <img
                                    src="https://storage.googleapis.com/assets-us-east4-propilatam-dev/website-assets/propi-web/loading_search.gif"
                                    alt=""
                                    width={30}
                                  />
                                </Box>
                              )}
                            </div>

                            <span className="text-sm font-normal text-[#757575] text-center block mt-1">
                              <b>Nota:</b> Se generará un link de pago rápido
                              para compartirlo
                            </span>
                          </div>
                        ) : (
                          <span className="text-xs font-normal px-2 py-2 rounded-lg text-center block mt-1 text-[#92400e] bg-[#fffbeb]">
                            <b>Advertencia!</b> No se puede asignar la unidad porque el usuario no cumple con las validaciones de KYC o está identificado como PEP.
                          </span>
                        ))}
                      {showShareOption && (
                        <div className="w-full mt-6">
                          <div className="py-2 rounde-lg mx-auto max-w-lg flex-row items-center justify-between overflow-hidden rounded-lg bg-[#D5F0E3] px-4 flex ">
                            <div className="flex flex-col items-start text-sm w-2/3">
                              <p className="font-semibold text-[#212121] text-sm">
                                Link de pago rápido
                              </p>
                              <p className="text-[#757575] truncate w-full">
                                {url}
                              </p>
                            </div>

                            <div className="">
                              <ul className="flex items-center space-x-3">
                                <li
                                  onClick={handleEnviarWhatsApp}
                                  className="inline-block"
                                >
                                  <Tooltip
                                    className="cursor-pointer"
                                    title="Compartir por WhatsApp"
                                    placement="top"
                                    enterTouchDelay={0}
                                    arrow
                                  >
                                    <IconBrandWhatsapp color="#212121" />
                                  </Tooltip>
                                </li>
                                <li
                                  onClick={handleCopiar}
                                  className="inline-block"
                                >
                                  <Tooltip
                                    className="cursor-pointer"
                                    title="Copiar enlace a portapapeles"
                                    placement="top"
                                    enterTouchDelay={0}
                                    arrow
                                  >
                                    <IconLink color="#212121" />
                                  </Tooltip>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      )}
                      <hr className="my-1 mt-3" />
                      <div className="w-full flex py-2">
                        <p className="w-1/2 text-[#212121] font-semibold text-sm">
                          Nombre
                        </p>
                        <p className="w-1/2 text-[#757575] text-sm font-normal text-right whitespace-nowrap overflow-ellipsis overflow-hidden">
                          {landlordInfoSelected?.first_name}{" "}
                          {landlordInfoSelected?.last_name}
                        </p>
                      </div>
                      <hr className="my-1" />
                      <div className="w-full flex py-2">
                        <p className="w-1/2 text-[#212121] font-semibold text-sm">
                          Correo
                        </p>
                        <p className="w-1/2 text-[#757575] text-sm font-normal text-right whitespace-nowrap overflow-ellipsis overflow-hidden">
                          {landlordInfoSelected?.email}
                        </p>
                      </div>
                      <hr className="my-1" />
                      <div className="w-full flex py-2">
                        <p className="w-1/2 text-[#212121] font-semibold text-sm">
                          Teléfono
                        </p>
                        <p className="w-1/2 text-[#757575] text-sm font-normal text-right whitespace-nowrap overflow-ellipsis overflow-hidden">
                          {landlordInfoSelected?.phone}
                        </p>
                      </div>
                      <hr className="my-1" />

                      {landlordInfoSelected?.prebooking_date !== null && (
                        <div className="w-full flex py-2">
                          <p className="w-1/2 text-[#212121] font-semibold text-sm">
                            Fecha pre reserva
                          </p>
                          <p className="w-1/2 text-[#757575] text-sm font-normal text-right whitespace-nowrap overflow-ellipsis overflow-hidden">
                            {landlordInfoSelected?.prebooking_date}
                          </p>
                        </div>
                      )}
                      {landlordInfoSelected?.kyc_info && (
                        <Fragment>
                          <hr className="my-1" />
                          <div className="w-full flex py-2">
                            <p className="w-1/2 text-[#212121] font-semibold text-sm">
                              Formulario KYC
                            </p>
                            <p className="w-1/2 text-[#757575] text-sm font-normal text-right whitespace-nowrap overflow-ellipsis overflow-hidden">
                              {formatKycStatus(
                                landlordInfoSelected?.kyc_info?.status
                              )}
                            </p>
                          </div>
                          <hr className="my-1" />
                          <div className="w-full flex py-2">
                            <p className="w-1/2 text-[#212121] font-semibold text-sm">
                              Fecha de Envío (KYC)
                            </p>
                            <p className="w-1/2 text-[#757575] text-sm font-normal text-right whitespace-nowrap overflow-ellipsis overflow-hidden">
                              {landlordInfoSelected?.kyc_info?.created_at}
                            </p>
                          </div>
                          <hr className="my-1" />
                          <div className="w-full flex py-2">
                            <p className="w-1/2 text-[#212121] font-semibold text-sm">
                              Fecha de Actualización (KYC)
                            </p>
                            <p className="w-1/2 text-[#757575] text-sm font-normal text-right whitespace-nowrap overflow-ellipsis overflow-hidden">
                              {landlordInfoSelected?.kyc_info?.updated_at}
                            </p>
                          </div>

                          <div className="w-full flex justify-between py-2">
                            <p className="w-1/2 text-[#212121] font-semibold text-sm"></p>
                            <button
                              onClick={() => viewKyc()}
                              className=" px-4 py-2 rounded-xl bg-[#212121] text-white text-sm font-semibold text-center flex justify-between items-center gap-2"
                            >
                              <IconSquareCheck /> Revisión de KYC
                            </button>
                          </div>
                        </Fragment>
                      )}
                    </div>
                  </div>
                </Grid>
              </Grid>
            )}
          </Box>
        </Modal>
      </>
    );
  }
);

CardPro.displayName = "CardPro";
export default CardPro;

/* 
  Modificado por: Daniel Bonilla
  Fecha: Septiembre 2025
  -  Se agregó la funcionalidad para mostrar cambiar de vista entre Grid y List.

*/